const mutations = {
    AUTH_REQUEST(state) {
        state.status = "loading";
        //state.showAlert=true,
        //state.alertMsg ='Please Wait',
        //state.alertType= 'primary'
    },

    AUTH_SUCCESS(state, payload) {
        state.status = "success";
        state.token = payload.token;
        state.user = payload.user;
        state.isLoggedIn = true;
    },

    AUTH_ERROR(state, payload) {
        (state.status = "error"),
            (state.isLoggedIn = false),
            (state.showAlert = true),
            (state.alertMsg = payload.msg),
            (state.alertType = "error");
    },

    LOGOUT(state) {
        (state.status = ""),
            (state.token = ""),
            (state.isLoggedIn = false),
            (state.showAlert = true),
            (state.alertMsg = "Logga ut framgångsrikt!"),
            (state.alertType = "success");
        state.user = {};
    },

    STEP1(state, payload) {
        state.schedule.title = payload.title;
        (state.schedule.description = payload.description),
            (state.schedule.location = payload.location),
            (state.schedule.theme = payload.theme);
        state.schedule.username = payload.username;
        state.schedule.customtheme = payload.customtheme;
    },

    STEP2(state, payload) {
        (state.schedule.time = payload.schedule),
            (state.schedule.deadlineReply = payload.replyDeadline);
        state.schedule.deadlineDate = payload.replyDate;
        state.schedule.oneAns = payload.oneAns;
        state.schedule.ifNeeded = payload.ifNeeded;
        state.schedule.contactInfo = payload.contactInfo;
        state.schedule.hidSchedule = payload.hidSchedule;
        state.schedule.adminOnly = payload.adminOnly;
        state.schedule.username = state.user.email;
        state.ci0 = payload.ci0
        state.ci1 = payload.ci1
        state.ci2 = payload.ci2
        state.ci3 = payload.ci3
        state.ci4 = payload.ci4

    },

    EVENT_CREATED(state, payload) {
        state.alertMsg = "Händelse skapades framgångsrikt";
        (state.link = payload),
            (state.showAlert = true),
            (state.alertType = "success");
    },
    PASSWORDRESET(state) {
        state.alertMsg = "Lösenord Återställ Länk skickad till din mail";
        (state.showAlert = true), (state.alertType = "success");
    },
    PASSRESETERROR(state) {
        state.alertMsg = "Ledsen ... Kontrollera e-postadressen du angav";
        (state.showAlert = true), (state.alertType = "error");
    },
    PASSWORDCHANGED(state) {
        state.alertMsg = "Lösenordet har ändrats";
        (state.showAlert = true), (state.alertType = "success");
    },
    PASSWORDSETERROR(state) {
        state.alertMsg = "Ledsen .. Ange giltig PIN-kod";
        (state.showAlert = true), (state.alertType = "error");
    },
    SHOWSCHEDULE(state, payload) {
        state.getSchedule.details = payload.schedule;
        state.getSchedule.dates = payload.time;
        (state.getSchedule.participants = payload.participants),
            (state.getSchedule.participantDates = payload.participants_date);
    },
    PARTICIPANTADDED(state) {
        state.showAlert = true;
        state.alertType = "success";
        state.alertMsg = "Ditt svar registrerades framgångsrikt, tack!";
    },

    USERDELETED(state) {
        state.showAlert = true;
        state.alertType = "success";
        state.alertMsg = "Användaren har tagits bort!";
    },

    SCHEDULEDELETED(state) {
        state.showAlert = true;
        state.alertType = "success";
        state.alertMsg = "Schemat raderas framgångsrikt!";
    },

    LOADING(state) {
        state.loading = true;
    },

    STOPLOADING(state) {
        state.loading = false;
    },

    SETEMAIL(state, payload) {
        state.email = payload;
    }
};

export default mutations;
